import React from "react";

const SubCategoriesModal = ({
  IssubCategories,
  toggleServicesCategoryModal,
  subCategories,
  baseUrl,
  subCategoriesServices,
  getCheckDetails,
  getOilDetails,
  getBatteryDetails,
  getTyreDetails,
  toggleSaveSubCategories,
}) => {
  return (
    IssubCategories && (
      <div
        className="modal fade show"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={IssubCategories ? "false" : "true"}
        style={{ display: "block" }}
      >
        <div className="modal-dialog orderDetails-modal" role="document">
          <div className="modal-content">
            <div className="modal-header orderDetails-modalHeader px-4">
              {subCategories && (
                <>
                  <i
                    onClick={() => toggleServicesCategoryModal()}
                    className="fa-solid fa-chevron-left cursor"
                  ></i>
                  <div className="d-flex w-50 justify-content-center align-items-center mx-auto">
                    <p
                      className="orderDetails-modalTitle fs-3 fw-semibold my-0 mx-2"
                      id="exampleModalLabel"
                    >
                      {subCategories.name}
                    </p>
                    <img
                      src={`${baseUrl}${subCategories.icon_url}`}
                      className="w-25"
                      alt={subCategories.name}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="modal-body orderDetails-modalBody px-3 py-2">
              <div className="services-container">
                {/* {subCategoriesServices.map((service) => (
                  <div
                    onClick={
                      service.type.name !== "change"
                        ? () => getCheckDetails(service.slug)
                        : service.name === "تغيير زيت و فلاتر"
                        ? () => getOilDetails(service.services[0].id)
                        : service.name === "تغيير البطاريه"
                        ? () => getBatteryDetails(service.services[0].id)
                        : () => getTyreDetails(service.services[0].id)
                    }
                    key={service.id}
                    className="service-card bg-opacity-10 my-2 p-4 rounded-3 text-end cursor"
                    style={{ backgroundColor: service.background_color }}
                  >
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <div>
                        {service?.selected === true && (
                          <i
                            className="fa-solid fa-circle-check fa-2x"
                            style={{ color: "hsl(93, 89.70%, 38.00%)" }}
                          ></i>
                        )}
                      </div>
                      <div className="d-flex justify-content-end align-items-center">
                        <p className="my-0 mx-2 fw-bold">{service.name}</p>
                        <img src={`${baseUrl}${service.icon_url}`} alt="" />
                      </div>
                    </div>
                    {service.services?.map((nested) => (
                      <div
                        key={nested.id}
                        className="d-flex justify-content-end align-items-center my-2"
                      >
                        <p className="my-0 mx-2">{nested.name}</p>
                        {nested?.selected === true ? (
                          <i
                            className="fa-solid fa-check"
                            style={{ color: "hsl(93, 89.70%, 38.00%)" }}
                          ></i>
                        ) : (
                          <i className="fa-solid fa-circle fa-xs text-muted"></i>
                        )}
                      </div>
                    ))}
                    {service.offers.map((offer) => (
                      <div
                        key={offer.id}
                        className="d-flex justify-content-end align-items-center my-2"
                      >
                        <p className="my-0 mx-2">{offer.name}</p>
                        {offer.selected === true ? (
                          <i
                            className="fa-solid fa-check"
                            style={{ color: "hsl(93, 89.70%, 38.00%)" }}
                          ></i>
                        ) : (
                          <i className="fa-solid fa-circle fa-xs text-muted"></i>
                        )}
                      </div>
                    ))}
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="w-50 text-start">
                        {service.control_type.properties.map((prop) => (
                          <img
                            key={prop.id}
                            style={{ width: "70%" }}
                            src={`${baseUrl}${prop.value}`}
                            alt=""
                          />
                        ))}
                      </div>
                      {service.price > 0 && (
                        <p className="mt-5 fs-5 fw-semibold">
                          {" "}
                          اجمالي المبلغ : {service.price} ج.م
                        </p>
                      )}
                    </div>
                  </div>
                ))} */}
                {subCategoriesServices.length === 0 ? (
                  <div className="service-card bg-opacity-10 my-2 p-4 rounded-3 text-end">
                    <div className="mb-3">
                      <label className="form-label">الاسم</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="ادخل اسم الخدمة"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">السعر</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="ادخل السعر"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">المواصفات</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="ادخل المواصفات"
                      />
                    </div>
                  </div>
                ) : (
                  subCategoriesServices.map((service) => (
                    <div
                      onClick={
                        service.type.name !== "change"
                          ? () => getCheckDetails(service.slug)
                          : service.name === "تغيير زيت و فلاتر"
                          ? () => getOilDetails(service.services[0].id)
                          : service.name === "تغيير البطاريه"
                          ? () => getBatteryDetails(service.services[0].id)
                          : () => getTyreDetails(service.services[0].id)
                      }
                      key={service.id}
                      className="service-card bg-opacity-10 my-2 p-4 rounded-3 text-end cursor"
                      style={{ backgroundColor: service.background_color }}
                    >
                      <div className="d-flex justify-content-between align-items-center py-2">
                        <div>
                          {service?.selected === true && (
                            <i
                              className="fa-solid fa-circle-check fa-2x"
                              style={{ color: "hsl(93, 89.70%, 38.00%)" }}
                            ></i>
                          )}
                        </div>
                        <div className="d-flex justify-content-end align-items-center">
                          <p className="my-0 mx-2 fw-bold">{service.name}</p>
                          <img src={`${baseUrl}${service.icon_url}`} alt="" />
                        </div>
                      </div>
                      {service.services?.map((nested) => (
                        <div
                          key={nested.id}
                          className="d-flex justify-content-end align-items-center my-2"
                        >
                          <p className="my-0 mx-2">{nested.name}</p>
                          {nested?.selected === true ? (
                            <i
                              className="fa-solid fa-check"
                              style={{ color: "hsl(93, 89.70%, 38.00%)" }}
                            ></i>
                          ) : (
                            <i className="fa-solid fa-circle fa-xs text-muted"></i>
                          )}
                        </div>
                      ))}
                      {service.offers.map((offer) => (
                        <div
                          key={offer.id}
                          className="d-flex justify-content-end align-items-center my-2"
                        >
                          <p className="my-0 mx-2">{offer.name}</p>
                          {offer.selected === true ? (
                            <i
                              className="fa-solid fa-check"
                              style={{ color: "hsl(93, 89.70%, 38.00%)" }}
                            ></i>
                          ) : (
                            <i className="fa-solid fa-circle fa-xs text-muted"></i>
                          )}
                        </div>
                      ))}
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="w-50 text-start">
                          {service.control_type.properties.map((prop) => (
                            <img
                              key={prop.id}
                              style={{ width: "70%" }}
                              src={`${baseUrl}${prop.value}`}
                              alt=""
                            />
                          ))}
                        </div>
                        {service.price > 0 && (
                          <p className="mt-5 fs-5 fw-semibold">
                            اجمالي المبلغ : {service.price} ج.م
                          </p>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className="modal-footer mx-auto">
              <button
                type="button"
                className="btn btn-dark px-5 fs-5"
                onClick={toggleSaveSubCategories}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default SubCategoriesModal;
